import { combineReducers } from 'redux';
import authReducer from './authSlice';
import commonReducer from './commonSlice';
import SignupStepPageReducer from './SignupStepPageSlice';
import roleReducer from './roleSlice';
import serviceReducer from './serviceSlice';
import signupReducer from './signupSlice';
import followUpReducer from './followUpSlice';
import todayAppointmentReducer from './todayAppointmentSlice';
import patientListReducer from './patientSlice';
const combineReducer = combineReducers({
  authReducer,
  commonReducer,
  SignupStepPageReducer,
  roleReducer,
  serviceReducer,
  signupReducer,
  followUpReducer,
  todayAppointmentReducer,
  patientListReducer
});

export default combineReducer;
